import angular from 'angular';
import './navbar.repository.js';
import template from './navbar.component.html';
import hamburgerIcon from '/src/assets/images/navigation/hamburger.svg';
import closeIcon from '/src/assets/images/navigation/close-nav.svg';
import 'owl.carousel';



angular
	.module('Toke')
	.component('appNavbar', {
		template,
		bindings: {
			data: '<'
		},
		controller: NavbarController
	});

NavbarController.$inject = ['navbarRepository', '$timeout', '$window', '$scope'];

function NavbarController(navbarRepository, $timeout, $window, $scope) {
	const vm = this;

	vm.logo = {};
	vm.menu = [];
	vm.popUp = {};
	vm.isMenuOpen = false;
	vm.isPopUpOpen = true;
	vm.hamburgerIcon = hamburgerIcon;
	vm.closeIcon = closeIcon;
	vm.slideRec = [];
	vm.mobileActions = []
	vm.isSticky = false;
	const STICKY_OFFSET = 80

	vm.$onInit = function () {
		if (vm.data) {
			vm.logo = vm.data.logo || {};
			vm.menu = vm.data.menu || [];
			vm.popUp = vm.data.popUp || {};
			vm.slideRec = vm.data.slideRec || [];
			vm.mobileActions = vm.data.mobileActions || [];
			initOwl();
		} else {
			navbarRepository.getNavigation().then(nav => {
				vm.logo = nav.logo;
				vm.menu = nav.menu;
				vm.popUp = nav.popUp;
				vm.slideRec = nav.slideRec || [];
				vm.mobileActions = nav.mobileActions || [];
				initOwl();

			});

		}

		angular.element($window).on('scroll', onScroll);
	};

	vm.toggleMenu = function () {
		const $menu = angular.element(
			document.querySelector('#navigationMobile'),

		);

		vm.isMenuOpen ? $menu.slideUp(300) : $menu.slideDown(300);
		vm.isMenuOpen = !vm.isMenuOpen;
	};

	vm.closePopUp = function () {
		const $popup = angular.element(document.querySelector('.navigation__popup-inner'));

		$popup.fadeOut(200, function () {
			const $scope = angular.element(document.getElementById('mainNavigation')).scope();
			$scope.$apply(() => {
				vm.isPopUpOpen = false;
			});
		});
	};

	function initOwl() {
		$timeout(() => {
			const $owl = angular.element('.navigation__owl');

			if ($owl.length && !$owl.hasClass('owl-loaded')) {
				$owl.owlCarousel({
					items: 1,
					loop: true,
					margin: 16,
					stagePadding: 40,
					dots: true,
					nav: false,
					autoplay: false,
					autoplayTimeout: 5000
				});
			}
		});
	}

	function onScroll() {
		const shouldStick = $window.pageYOffset > STICKY_OFFSET;

		if (shouldStick !== vm.isSticky) {
			$scope.$applyAsync(() => {
				vm.isSticky = shouldStick;
			});
		}
	}

}
